<template>
   <div id="DrugInteractions">
      <BoxInfoPatient v-if="this.PatientCode" :PatientCode="this.PatientCode" :AdmissionRecordId="this.AdmissionRecordId" v-bind:OpenInModal="true"></BoxInfoPatient>


        <div class="IncidentContainerBox noNum mt-2" v-if="this.PatientCode">
            <div class="row">
                <div class="col-md-12">
                    <div class="grid-margin stretch-card">
                        <div class="card activeCard">
                            <div class="card-body">
                                <div class="d-flex align-items-start justify-content-between">
                                    <h6
                                        v-b-toggle="'InfoMed'"
                                        class="card-title flex-grow lower-line text-truncate"
                                    >
                                        {{ $t('DrugOrdersInbox.ViewAllMed') }}
                                    </h6>
                                </div>
                                <b-collapse visible id="InfoMed" class="small-info ml-2"
                                    ><small>{{
                                        $t('modalMarsMed.clickTitleTextPatient')
                                    }}</small></b-collapse
                                >
                                <b-collapse id="InfoMed">
                                    <div class="card activeCard">
                                        <div class="container-mars">
                                            <div class="card-container">
                                                <div class="card-body">
                                                    <b-row>
                                                        <div class="col-sm-12 col-md-3">
                                                            <MdSelect
                                                                v-bind:Label="$t('Medication.RxStatus')"
                                                                v-bind:Options="RxStatusList"
                                                                v-bind:FieldDescription="'name'"
                                                                v-bind:FieldCode="'value'"
                                                                v-bind:Model="ModelRxStatus"
                                                                v-bind:Multiple="false"
                                                                :Input="ChangeDropDownRxStatus"
                                                                v-bind:Name="'rxstatus_select'"
                                                                id="rxtatus_select"
                                                            />
                                                        </div>
                                                        <div class="col-sm-12 col-md-9 mb-4">
                                                            <div
                                                                class="textlabel"
                                                                :data-label="
                                                                    this.$t('Shared.SearchElements')
                                                                "
                                                            >
                                                                <div class="input-group" dir="ltr">
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        :dir="dirInput"
                                                                        v-model="
                                                                            parameter.SearchCriteria
                                                                        "
                                                                        @keyup.enter="
                                                                            getPatientMedications2(
                                                                                medications.patientCode
                                                                            )
                                                                        "
                                                                    />

                                                                    <div class="input-group-append">
                                                                        <MdButton
                                                                            v-bind:Name="
                                                                                'btnsearchinput'
                                                                            "
                                                                            v-bind:VariantProp="
                                                                                'btn btn-sm search-attached'
                                                                            "
                                                                            v-bind:IconClass="
                                                                                'mdi mdi-magnify'
                                                                            "
                                                                            v-on:click="
                                                                                getPatientMedications2(
                                                                                    medications.patientCode
                                                                                )
                                                                            "
                                                                        >
                                                                        </MdButton>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-row>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <MdTable
                                                                v-bind:fields="fields2"
                                                                v-bind:items="items2"
                                                                v-bind:totalRows="totalRows2"
                                                                v-bind:showMessageIsEmpty="
                                                                    ShowMessageIsEmpty
                                                                "
                                                                v-bind:currentPage="currentPage2"
                                                                v-bind:perPage="perPage2"
                                                                v-bind:IsMedicationList="true"
                                                                :viewIconEvent="ViewMed"
                                                                v-bind:pageOptions="pageOptions2"
                                                                :onFiltered="onFiltered2"
                                                                :pageChanged="pageChanged2"
                                                                :onRowSelected="onRowSelected2"
                                                                :otherIcon="'printer-fill'"
                                                                :otherIconEvent="ShowReport"
                                                                :RowClick="RowClicked"
                                                                :perPageFunction="PerPageFunction2"
                                                            >
                                                            </MdTable>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <b-row class="main-container">
    <b-col md="3" sm="12" class="medications-column">
      <b-card class="medications-card">
        <MdLookupMultiSelect
                    v-bind:Label="$t('Medication.Drugs')"
                    v-bind:ModelCode="parameters.DrugCodeList"
                    v-bind:RefCode="'Drugs'"
                    v-bind:Api="'Drugs'"
                    v-bind:FieldCode="'drugCode'"
                    v-bind:FieldDescription="'drugname'"
                    :SearchTitle="$t('Medication.Drugs')"
                    :GetValues="getValuesDrugs"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :SearchFieldCode="'Code'"
                    :ServerSidePagination="true"
                    v-bind:Fields="BaseFields"
                />

        <div class="medications-list">
          <div
            v-for="(medication, index) in medications" :key="medication.drugCode || index" class="medication-row">


                <b-button-group class="groupActions mr-1">
                    <b-button size="sm" variant="light">
                        <MdCheckBox
                            aria-hidden="true"
                            :Name="'checkboxShowAdd'"
                            :ClassProp="'medication-checkbox'"
                            :CheckedValue="true"
                            :UncheckedValue="false"
                            v-model="medication.selected"
                        />
                    </b-button>

            <b-button size="sm"
                variant="light" @click="removeMedication(index)">
                <b-icon icon="trash-fill" aria-hidden="true" @click="removeMedication(index)"></b-icon>
            </b-button>
            </b-button-group>


            <span
                v-b-tooltip.hover
                :title="medication.drugName"
                class="medication-name"
            >
                {{ medication.drugName }}
            </span>
            </div>
        </div>

      </b-card>
    </b-col>


    <!-- ÁREA DERECHA -->
    <b-col md="9" sm="12" class="content-column">
      <div class="content-area">
            <MdTabList v-bind:TabList="tablist" v-bind:ShowTabList="false" class="mb-2">
                <div class="tab-content tab-content-custom-pill" id="pills-tabContent-custom">

                <div class="tab-pane fade" id="drug_i" role="tabpanel">
                    <div v-if="sortedDDIObjects.length === 0" v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite">
                      <div class="text-center my-2">No Drug Interactions to show.</div>
                   </div>
                    <div class="screening-box">

                       <div v-for="(item, index) in sortedDDIObjects" :key="index">
                            <div class="alert-header">


                                    <div class="warning-container">
                                        <svg
                                        class="warning-icon"
                                        viewBox="0 0 40 40"
                                        xmlns="http://www.w3.org/2000/svg"
                                        >

                                        <path
                                            d="M20 3L38 35H2L20 3Z"
                                            :fill="item.Severity === '1' ? '#ff3b30': item.Severity === '2' ? '#ff8638' : item.Severity === '3' ? '#ffb921':''"
                                        />


                                        <path
                                            d="M20 12V23"
                                            stroke="#ffffff"
                                            stroke-width="2.5"
                                            stroke-linecap="round"
                                        />

                                        <circle
                                            cx="20"
                                            cy="28"
                                            r="1.6"
                                            fill="#ffffff"
                                        />
                                        </svg>
                                    </div>


                                    <div class="alert-info">

                                      <div :class="item.Severity === '1' ?
                                        'severity1 contraindicated' : item.Severity === '2' ?
                                        'severity2' : item.Severity === '3' ? 'severity3' :''">

                                        <span v-if="item.Severity === '1'">
                                            1-Contraindicated
                                        </span>
                                        <span v-else-if="item.Severity === '2'">
                                            2-Serious
                                        </span>
                                        <span v-else>
                                            3-Moderate
                                        </span>

                                        </div>

                                        <div class="alert-id">
                                         ID : {{item.InteractionID}}
                                        </div>

                                        <div class="description">
                                        Description : {{item.InteractionDesc}}
                                        </div>

                                    </div>

                            </div>



                        <div class="alert-body">
                            <div class="message">
                               {{item.ClinicalEffectsNarrative}}
                            </div>

                            <div class="medications">
                                <div class="medication" v-for="(med, medindex) in item.ScreenDrugs" :key="medindex">
                                    {{med.DrugDesc}}
                                </div>
                            </div>

                            <div class="separator"></div>
                                <a href="#" class="monograph" @click.prevent>
                                    <span class="document-icon">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </span>
                                <span v-on:click="MonographClick(item.MonographID)">Professional Monograph ({{item.MonographID}})</span>
                                </a>

                              </div>
                              <br>
                        </div>


                    </div>
                </div>

                <div class="tab-pane fade show active" id="duplicate_t" role="tabpanel">
                    <div v-if="sortedDPTObjects.length === 0" v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite">
                      <div class="text-center my-2">No Duplicate Therapy alerts to show.</div>
                   </div>

                    <div class="screening-box" v-for="(item, index) in sortedDPTObjects" :key="index">
                        <div class="duplicate-therapy-box">
                            <!--<div class="duplicate-header">
                                {{item.ScreenMessage}}
                            </div>-->
                            <div class="duplicate-header">
                                {{item.DPTClasses[0].DPTClassDesc}}
                            </div>

                            <div class="duplicate-body">
                                <div v-for="(element, indexDrug) in item.ScreenDrugs" :key="indexDrug" class="duplicate-medication">
                                    <span class="mx-1">{{element.DrugDesc}}</span>
                                </div>
                            </div>
                        </div>
                    </div>




                </div>

                </div>
            </MdTabList>
      </div>
    </b-col>

  </b-row>


   <BaseModal
          v-if="VisibleProfessionalMonograph"
          :key="'ModalDrugInteractionProfessionalMonograph'"
          ModalId="ModalDrugInteractionProfessionalMonograph"
          :TitleWindow="this.$t('FirstDataBank.DrugInteractionProfessionalMonograph')"
          :width="'65%'"
          :height="'60vh'"

          :HideModalFun="ProfessionalMonographOnCancel"
          @Close="ProfessionalMonographOnCancel"
          :buttons="[
              { text: $t('Shared.Close'), variant: 'secondary', action: 'Close' }
          ]">

          <b-row>
            <b-col md="6" class="border-right-column">
                 <div v-for="(item,key) in ProfessionalMonographSectionList" :key="key"  class="mb-1">
                     <b>{{item.title}}</b><br>
                     <p class="justified-text">{{item.text}}</p>
                 </div>
            </b-col>
             <b-col md="6">
                 <b>{{this.$t('FirstDataBank.References')}} </b><br>
                <div v-for="(item,key) in ProfessionalMonographReferenceList" :key="key"  class="mb-1">
                     <p class="justified-text">{{item.referenceText}}</p>
                 </div>
             </b-col>
          </b-row>


      </BaseModal>

       <PatientMedicationsRep
            v-if="isReportVisible"
            :closeWindow="closeParamRepWindow"
            :patientCode="this.PatientCode"
            :recNo="recNoToReport"
        />

        <ModalDrugOrderMedication
            v-if="VisibleModalViewMed"
            :RecordId="RecordId"
            :PatientCode="this.PatientCode"
            :isControlledSubstance="isControlledSubstance"
            :isUAE="isNRC"
            @Print="Print"
            :TitleWindow="$t('DrugOrdersInboxFill.MedicationInfo')"
            @OnModalDrugOrderInboxClose="CloseModalMed"
            ModalId="'ModalIdModalViewMedFill'"
        >
        </ModalDrugOrderMedication>

        <DxPopup
            :visible="isReportPatientMedicationVisible"
            :drag-enabled="true"
            :close-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :hide-on-parent-scroll="true"
            :title="$t('PatientMedications.ReportMedications')"
            @hidden="onHiddenMedicationReport"
            :resize-enabled="true"
            shading-color="rgba(0, 0, 0, 0.5)"
            height="94vh"
            width="97vw"
            @showing="onShowing"
            :wrapper-attr="popupAttributes"
        >
            <ReportViewer
                ref="patientMedications"
                :ReportName="'PatientMedications'"
                :ReportTitle="$t('PatientMedications.ReportMedications')"
                :IsAnAPIReport="true"
            />
        </DxPopup>

   </div>
</template>

<script>
import MedicationService from '@/services/medication.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import EnumService from '@/services/enum.service';
import FirstDataBankService from '@/services/firstdatabank.service'
import ModalDrugOrderMedication from '@/components/pages/drugordersinbox/modalDrugOrderViewMedication';
import { DxPopup } from 'devextreme-vue/popup';
import Utils from "@/common/utils";
export default {
     props:{
        PatientCode:String,
        AdmissionRecordId:String
    },
    mixins: [ShowMessage, DBFunctions],
    components:{DxPopup,ModalDrugOrderMedication},
  name: 'DrugInteraction',
  data(){
    return{
        RxStatusList: EnumService.ClinicalMedicatiosRxStatus,
        ModelRxStatus: { value: 'ActiveDuration', name: this.$t('Shared.ActDuration') },
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        ShowMessageIsEmpty: false,
        items2: [],
        fields2: [
            {
                key: 'startDateTime',
                sortable: true,
                label: this.$t('Shared.StartDate'),
                class: 'text-rigth'
            },
            {
                key: 'endDateTime',
                sortable: true,
                label: this.$t('Shared.EndDate'),
                class: 'text-rigth'
            },
            { key: 'recordId', sortable: true, label: 'RecordId', class: 'hidden' },
            { key: 'day', sortable: true, label: this.$t('Shared.Days'), class: 'text-rigth' },
            {
                key: 'drugName',
                sortable: true,
                label: this.$t('Shared.DrugName'),
                class: 'text-rigth'
            },
            {
                key: 'activeIngredients',
                sortable: true,
                label: this.$t('Shared.activeIngredients'),
                class: 'text-rigth'
            },
            { key: 'sig', sortable: true, label: this.$t('Shared.Sig'), class: 'text-rigth' },
            {
                key: 'prescriber',
                sortable: true,
                label: this.$t('Shared.Prescriber'),
                class: 'text-rigth'
            },
            {
                key: 'internalStatus',
                sortable: true,
                label: this.$t('Shared.InternalStatus'),
                class: 'text-rigth'
            },
            {
                key: 'stopDateTime',
                sortable: true,
                label: this.$t('Shared.StopDate'),
                class: 'text-rigth'
            }
        ],
        totalRows2: 0,
        currentPage2: 1,
        perPage2: 10,
        pageOptions2: [5, 10, 15, 20, 30, 40, 50],
        isReportPatientMedicationVisible: false,
        isNRC: this.$store.state.companies.isNRC,
        isControlledSubstance:'',
        params2: {
            PatientCode: ''
        },
        recNoToReport: '',
        isReportVisible: false,
        RecordId:"",
        VisibleModalViewMed: false,
        parameters: {
            DrugCodeList: [],
            PageSize: 10,
            PageNumber: 1
        },
        emptyRecordsStyle: {
            backgroundColor: '#CF0',
            fontWeight: 'bold !important',
            textTransform: 'uppercase',
            padding: '2px',
            borderRadius: '50px',
            animation: 'fadeOut 10s ease-in-out infinite'
        },
        BaseFields: [
            { key: 'drugname', sortable: true, label: this.$t('Shared.DrugName') },
            { key: 'activeingred', sortable: true, label: this.$t('Shared.activeIngredients') },
            { key: 'dosage', sortable: true, label: this.$t('Shared.Dosage') },
            { key: 'form', sortable: true, label: this.$t('Shared.Form') },
            { key: 'drugCode', sortable: true, label: this.$t('Shared.DrugCode') }
        ],
        tablist: [
            {id:1, title: "Drug Interactions", link: '#drug_i',href:"drug_i", active: true},
            {id:2, title: "Duplicate Therapy", link: '#duplicate_t',href:"duplicate_t", active:false},
        ],
        medications: [],
        Screen:{
            DDIScreen:{
                 objects: [
            {
                "ScreenMessage": "ARIPiprazole 30 mg tablet and itraconazole 100 mg capsule may interact based on the potential interaction between ARIPIPRAZOLE IR and STRONG CYP3A4 INHIB; ATAZANAVIR; DARUNAVIR.",
                "ClinicalEffects": [
                    {
                        "ClinicalEffectCode": "INF",
                        "ClinicalEffectDesc": "Increased effect of the former drug"
                    }
                ],
                "InteractionDesc": "ARIPIPRAZOLE IR/STRONG CYP3A4 INHIB; ATAZANAVIR; DARUNAVIR",
                "Severity": "3",
                "ScreenDrug1": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "ARIPiprazole 30 mg tablet",
                    "DrugID": "446835",
                    "DrugConceptType": 3
                },
                "ScreenDrug2": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "itraconazole 100 mg capsule",
                    "DrugID": "288690",
                    "DrugConceptType": 3
                },
                "HasHumanClinicalTrial": false,
                "HasCaseReports": false,
                "HasMeetingAbstract": false,
                "HasVitroOrAnimalStudy": false,
                "HasMfgInfo": true,
                "HasReview": true,
                "MonographID": 1222,
                "InteractionID": 1222,
                "SeverityDesc": "Moderate Interaction: Assess the risk to the patient and take action as needed. ",
                "EDIPageReference": "18/902.00",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "ARIPiprazole 30 mg tablet",
                        "DrugID": "446835",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "itraconazole 100 mg capsule",
                        "DrugID": "288690",
                        "DrugConceptType": 3
                    }
                ],
                "ClinicalEffectsNarrative": "Concurrent administration of a strong CYP3A4 inhibitor may result in elevated levels of and toxicity from aripiprazole.(1-2)"
            },
            {
                "ScreenMessage": "carBAMazepine (bulk) powder and itraconazole 100 mg capsule may interact based on the potential interaction between SELECTED ANTICONVULSANTS; BARBITURATES and SLT AZOLE ANTIFUNGALS.",
                "ClinicalEffects": [
                    {
                        "ClinicalEffectCode": "AVD",
                        "ClinicalEffectDesc": "Avoid concurrent use when possible"
                    },
                    {
                        "ClinicalEffectCode": "MAR",
                        "ClinicalEffectDesc": "Adverse reaction with both drugs"
                    }
                ],
                "InteractionDesc": "SELECTED ANTICONVULSANTS; BARBITURATES/SLT AZOLE ANTIFUNGALS",
                "Severity": "2",
                "ScreenDrug1": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "carBAMazepine (bulk) powder",
                    "DrugID": "169844",
                    "DrugConceptType": 3
                },
                "ScreenDrug2": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "itraconazole 100 mg capsule",
                    "DrugID": "288690",
                    "DrugConceptType": 3
                },
                "HasHumanClinicalTrial": true,
                "HasCaseReports": true,
                "HasMeetingAbstract": false,
                "HasVitroOrAnimalStudy": true,
                "HasMfgInfo": true,
                "HasReview": true,
                "MonographID": 1663,
                "InteractionID": 1663,
                "SeverityDesc": "Severe Interaction: Action is required to reduce the risk of severe adverse interaction. ",
                "EDIPageReference": "05/008.07",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "carBAMazepine (bulk) powder",
                        "DrugID": "169844",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "itraconazole 100 mg capsule",
                        "DrugID": "288690",
                        "DrugConceptType": 3
                    }
                ],
                "ClinicalEffectsNarrative": "Concurrent use of fluconazole, itraconazole or ketoconazole may result in elevated levels of and toxicity from carbamazepine, phenobarbital and phenytoin.Concurrent use of barbiturates, carbamazepine, phenobarbital or phenytoin with itraconazole or ketoconazole(5,14-16) may result in decreased effectiveness or failure of antifungal therapy."
            },
            {
                "ScreenMessage": "ARIPiprazole 30 mg tablet and carBAMazepine (bulk) powder may interact based on the potential interaction between SELECTED ANTIPSYCHOTICS and STRONG CYP3A4 INDUCERS.",
                "ClinicalEffects": [
                    {
                        "ClinicalEffectCode": "DEF",
                        "ClinicalEffectDesc": "Decreased effect of the former drug"
                    }
                ],
                "InteractionDesc": "SELECTED ANTIPSYCHOTICS/STRONG CYP3A4 INDUCERS",
                "Severity": "2",
                "ScreenDrug1": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "ARIPiprazole 30 mg tablet",
                    "DrugID": "446835",
                    "DrugConceptType": 3
                },
                "ScreenDrug2": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "carBAMazepine (bulk) powder",
                    "DrugID": "169844",
                    "DrugConceptType": 3
                },
                "HasHumanClinicalTrial": true,
                "HasCaseReports": true,
                "HasMeetingAbstract": false,
                "HasVitroOrAnimalStudy": false,
                "HasMfgInfo": true,
                "HasReview": true,
                "MonographID": 1296,
                "InteractionID": 1296,
                "SeverityDesc": "Severe Interaction: Action is required to reduce the risk of severe adverse interaction. ",
                "EDIPageReference": "18/902.00",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "ARIPiprazole 30 mg tablet",
                        "DrugID": "446835",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "carBAMazepine (bulk) powder",
                        "DrugID": "169844",
                        "DrugConceptType": 3
                    }
                ],
                "ClinicalEffectsNarrative": "Strong CYP3A4 inducers may result in decreased levels and effectiveness of aripiprazole, brexpiprazole, and risperidone.(1-3)"
            },
            {
                "ScreenMessage": "itraconazole 100 mg capsule and omeprazole (bulk) 100 % powder may interact based on the potential interaction between ITRACONAZOLE; KETOCONAZOLE and AGENTS AFFECTING GASTRIC PH.",
                "ClinicalEffects": [
                    {
                        "ClinicalEffectCode": "DEF",
                        "ClinicalEffectDesc": "Decreased effect of the former drug"
                    }
                ],
                "InteractionDesc": "ITRACONAZOLE; KETOCONAZOLE/AGENTS AFFECTING GASTRIC PH",
                "Severity": "3",
                "ScreenDrug1": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "itraconazole 100 mg capsule",
                    "DrugID": "288690",
                    "DrugConceptType": 3
                },
                "ScreenDrug2": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "omeprazole (bulk) 100 % powder",
                    "DrugID": "449493",
                    "DrugConceptType": 3
                },
                "HasHumanClinicalTrial": true,
                "HasCaseReports": true,
                "HasMeetingAbstract": false,
                "HasVitroOrAnimalStudy": true,
                "HasMfgInfo": true,
                "HasReview": true,
                "MonographID": 239,
                "InteractionID": 239,
                "SeverityDesc": "Moderate Interaction: Assess the risk to the patient and take action as needed. ",
                "EDIPageReference": "08/048.50",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "itraconazole 100 mg capsule",
                        "DrugID": "288690",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "omeprazole (bulk) 100 % powder",
                        "DrugID": "449493",
                        "DrugConceptType": 3
                    }
                ],
                "ClinicalEffectsNarrative": "Simultaneous administration of an antacid, buffered didanosine, a H2 antagonist, or a proton-pump inhibitor may result in decreased therapeutic effects of the azole antifungal."
            },
            {
                "ScreenMessage": "omeprazole (bulk) 100 % powder and carBAMazepine (bulk) powder may interact based on the potential interaction between ESOMEPRAZOLE; OMEPRAZOLE and CARBAMAZEPINE.",
                "ClinicalEffects": [
                    {
                        "ClinicalEffectCode": "DEF",
                        "ClinicalEffectDesc": "Decreased effect of the former drug"
                    },
                    {
                        "ClinicalEffectCode": "INL",
                        "ClinicalEffectDesc": "Increased effect of the latter drug"
                    }
                ],
                "InteractionDesc": "ESOMEPRAZOLE; OMEPRAZOLE/CARBAMAZEPINE",
                "Severity": "3",
                "ScreenDrug1": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "omeprazole (bulk) 100 % powder",
                    "DrugID": "449493",
                    "DrugConceptType": 3
                },
                "ScreenDrug2": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "carBAMazepine (bulk) powder",
                    "DrugID": "169844",
                    "DrugConceptType": 3
                },
                "HasHumanClinicalTrial": true,
                "HasCaseReports": false,
                "HasMeetingAbstract": false,
                "HasVitroOrAnimalStudy": false,
                "HasMfgInfo": true,
                "HasReview": true,
                "MonographID": 3066,
                "InteractionID": 3066,
                "SeverityDesc": "Moderate Interaction: Assess the risk to the patient and take action as needed. ",
                "EDIPageReference": "18/902.00",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "omeprazole (bulk) 100 % powder",
                        "DrugID": "449493",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "carBAMazepine (bulk) powder",
                        "DrugID": "169844",
                        "DrugConceptType": 3
                    }
                ],
                "ClinicalEffectsNarrative": "Concurrent use of agents which induce both CYP2C19 and CYP3A4 decrease systemic exposure and may result in decreased effectiveness of esomeprazole and omeprazole.  Concurrent use of esomeprazole or omeprazole with carbamazepine may increase systemic exposure and may result in increased toxicity of carbamazepine.(1-8)"
            },
            {
                "ScreenMessage": "itraconazole 100 mg capsule and pantoprazole 40 mg tablet,delayed release may interact based on the potential interaction between ITRACONAZOLE; KETOCONAZOLE and AGENTS AFFECTING GASTRIC PH.",
                "ClinicalEffects": [
                    {
                        "ClinicalEffectCode": "DEF",
                        "ClinicalEffectDesc": "Decreased effect of the former drug"
                    }
                ],
                "InteractionDesc": "ITRACONAZOLE; KETOCONAZOLE/AGENTS AFFECTING GASTRIC PH",
                "Severity": "3",
                "ScreenDrug1": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "itraconazole 100 mg capsule",
                    "DrugID": "288690",
                    "DrugConceptType": 3
                },
                "ScreenDrug2": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "pantoprazole 40 mg tablet,delayed release",
                    "DrugID": "238235",
                    "DrugConceptType": 3
                },
                "HasHumanClinicalTrial": true,
                "HasCaseReports": true,
                "HasMeetingAbstract": false,
                "HasVitroOrAnimalStudy": true,
                "HasMfgInfo": true,
                "HasReview": true,
                "MonographID": 239,
                "InteractionID": 239,
                "SeverityDesc": "Moderate Interaction: Assess the risk to the patient and take action as needed. ",
                "EDIPageReference": "08/048.50",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "itraconazole 100 mg capsule",
                        "DrugID": "288690",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "pantoprazole 40 mg tablet,delayed release",
                        "DrugID": "238235",
                        "DrugConceptType": 3
                    }
                ],
                "ClinicalEffectsNarrative": "Simultaneous administration of an antacid, buffered didanosine, a H2 antagonist, or a proton-pump inhibitor may result in decreased therapeutic effects of the azole antifungal."
            },
            {
                "ScreenMessage": "itraconazole 100 mg capsule and atorvastatin 10 mg tablet may interact based on the potential interaction between ITRACONAZOLE and ATORVASTATIN (<=20MG).",
                "ClinicalEffects": [
                    {
                        "ClinicalEffectCode": "ARL",
                        "ClinicalEffectDesc": "Adverse reaction of the latter drug"
                    }
                ],
                "InteractionDesc": "ITRACONAZOLE/ATORVASTATIN (<=20MG)",
                "Severity": "3",
                "ScreenDrug1": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "itraconazole 100 mg capsule",
                    "DrugID": "288690",
                    "DrugConceptType": 3
                },
                "ScreenDrug2": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "atorvastatin 10 mg tablet",
                    "DrugID": "170427",
                    "DrugConceptType": 3
                },
                "HasHumanClinicalTrial": true,
                "HasCaseReports": false,
                "HasMeetingAbstract": false,
                "HasVitroOrAnimalStudy": false,
                "HasMfgInfo": true,
                "HasReview": false,
                "MonographID": 2242,
                "InteractionID": 2242,
                "SeverityDesc": "Moderate Interaction: Assess the risk to the patient and take action as needed. ",
                "EDIPageReference": "18/901.00",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "itraconazole 100 mg capsule",
                        "DrugID": "288690",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "atorvastatin 10 mg tablet",
                        "DrugID": "170427",
                        "DrugConceptType": 3
                    }
                ],
                "ClinicalEffectsNarrative": "Concurrent administration may result in increased levels of atorvastatin, which may result in an increased risk of rhabdomyolysis."
            },
            {
                "ScreenMessage": "itraconazole 100 mg capsule and simvastatin 40 mg tablet may interact based on the potential interaction between ITRACONAZOLE and SELECTED HMG-COA REDUCTASE INHIBITORS.",
                "ClinicalEffects": [
                    {
                        "ClinicalEffectCode": "ARL",
                        "ClinicalEffectDesc": "Adverse reaction of the latter drug"
                    },
                    {
                        "ClinicalEffectCode": "LBC",
                        "ClinicalEffectDesc": "Labeling conflicts between countries or products"
                    }
                ],
                "InteractionDesc": "ITRACONAZOLE/SELECTED HMG-COA REDUCTASE INHIBITORS",
                "Severity": "1",
                "ScreenDrug1": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "itraconazole 100 mg capsule",
                    "DrugID": "288690",
                    "DrugConceptType": 3
                },
                "ScreenDrug2": {
                    "DrugDose": null,
                    "Prospective": true,
                    "DrugDesc": "simvastatin 40 mg tablet",
                    "DrugID": "209275",
                    "DrugConceptType": 3
                },
                "HasHumanClinicalTrial": true,
                "HasCaseReports": true,
                "HasMeetingAbstract": false,
                "HasVitroOrAnimalStudy": true,
                "HasMfgInfo": true,
                "HasReview": true,
                "MonographID": 298,
                "InteractionID": 298,
                "SeverityDesc": "Contraindicated Drug Combination: This drug combination is contraindicated and generally should not be dispensed or administered to the same patient. ",
                "EDIPageReference": "18/901.00",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "itraconazole 100 mg capsule",
                        "DrugID": "288690",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "simvastatin 40 mg tablet",
                        "DrugID": "209275",
                        "DrugConceptType": 3
                    }
                ],
                "ClinicalEffectsNarrative": "Concurrent administration of itraconazole may result in increased levels of atorvastatin, lovastatin, or simvastatin, which may result in an increased risk of rhabdomyolysis."
            }
        ],
            },
            DPTScreen:{
            objects: [
            {
                "ScreenMessage": "The use of cetirizine 10 mg tablet and loratadine 10 mg disintegrating tablet may represent a duplication of drug therapy or pharmacologic effect based on their mutual association with the duplicate therapy class of Antihistamines.",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "cetirizine 10 mg tablet",
                        "DrugID": "170282",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "loratadine 10 mg disintegrating tablet",
                        "DrugID": "161399",
                        "DrugConceptType": 3
                    }
                ],
                "DPTClasses": [
                    {
                        "DuplicateAllowance": 0,
                        "UseAllowanceSource": true,
                        "DPTClassDesc": "Antihistamines",
                        "DPTClassID": "1058"
                    }
                ],
                "IsNonActionable": false
            },
            {
                "ScreenMessage": "The use of atorvastatin 10 mg tablet, rosuvastatin 40 mg tablet, and simvastatin 40 mg tablet may represent a duplication of drug therapy or pharmacologic effect based on their mutual association with the duplicate therapy class of Antihyperlipidemics HMGCo-A Reductase Inhibitors (Statins).",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "simvastatin 40 mg tablet",
                        "DrugID": "209275",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "atorvastatin 10 mg tablet",
                        "DrugID": "170427",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "rosuvastatin 40 mg tablet",
                        "DrugID": "451296",
                        "DrugConceptType": 3
                    }
                ],
                "DPTClasses": [
                    {
                        "DuplicateAllowance": 0,
                        "UseAllowanceSource": true,
                        "DPTClassDesc": "Antihyperlipidemics HMGCo-A Reductase Inhibitors (Statins)",
                        "DPTClassID": "483"
                    }
                ],
                "IsNonActionable": false
            },
            {
                "ScreenMessage": "The use of ibuprofen 300 mg tablet and naproxen 375 mg tablet may represent a duplication of drug therapy or pharmacologic effect based on their mutual association with the duplicate therapy class of Non-Steroidal Anti-Inflammatory (NSAID) and Salicylates.",
                "ScreenDrugs": [
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "ibuprofen 300 mg tablet",
                        "DrugID": "236012",
                        "DrugConceptType": 3
                    },
                    {
                        "DrugDose": null,
                        "Prospective": true,
                        "DrugDesc": "naproxen 375 mg tablet",
                        "DrugID": "163709",
                        "DrugConceptType": 3
                    }
                ],
                "DPTClasses": [
                    {
                        "DuplicateAllowance": 0,
                        "UseAllowanceSource": true,
                        "DPTClassDesc": "Non-Steroidal Anti-Inflammatory (NSAID) and Salicylates",
                        "DPTClassID": "276"
                    }
                ],
                "IsNonActionable": false
            }
        ],
            }
        },
        VisibleProfessionalMonograph:false,
        ProfessionalMonographSectionList:[],
        ProfessionalMonographReferenceList:[],
    }
  },

  computed: {
    sortedDDIObjects() {
        if (!this.Screen?.DDIScreen?.objects) {
            return [];
        }

        return [...this.Screen.DDIScreen.objects].sort(
            (a, b) => Number(a.Severity) - Number(b.Severity)
        );
    },

    sortedDPTObjects(){
        return [...this.Screen.DPTScreen.objects];
    }
},

  methods:{
    ChangeDropDownRxStatus(v) {
            this.ModelRxStatus = v !== null ? v : { value: 'All', name: this.$t('Shared.All') };
            this.getPatientMedications2(this.medications.patientCode);
        },

          async getPatientMedications2(patientCode) {
            var params2 = {
                PatientCode: patientCode,
                Status: this.ModelRxStatus.value,
                PageNumber: this.currentPage2,
                PageSize: this.perPage2,
                SearchCriteria: this.parameter.SearchCriteria ? this.parameter.SearchCriteria : '',
                buildingRestriction: this.$store.state.restrictions.buildingLocation
            };
            await MedicationService.getAll(params2)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items2 = response.data;
                        this.totalRows2 = this.items2.length > 0 ? this.items2[0].maxRows : 0;
                        this.items2.forEach(function(item) {
                            if (item.startDateTime)
                                item.startDateTime = Utils.formatterDateTimeToString(
                                    item.startDateTime
                                );
                            if (item.endDateTime)
                                item.endDateTime = Utils.formatterDateTimeToString(
                                    item.endDateTime
                                );
                            if (item.stopDateTime)
                                item.stopDateTime = Utils.formatterDateTimeToString(
                                    item.stopDateTime
                                );
                        });
                        if (this.items2.length === 0) {
                            this.ShowMessageIsEmpty = true;
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        closeParamRepWindow() {
            this.isReportVisible = false;
            this.recNoToReport = '';
        },

         popupAttributes() {},

        onHiddenMedicationReport() {
            this.isReportPatientMedicationVisible = false;
        },

        onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0];
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px';
        },

        Print() {
            let reportParams = [];
            reportParams.push({ paramName: 'patientCode', paramValue: this.PatientCode ?? null });
            reportParams.push({ paramName: 'recNo', paramValue: this.recordIdSelected ?? null });
            reportParams.push({
                paramName: 'isControlledSubstance',
                paramValue: this.medications.drugTypeCode ?? null
            });
            reportParams.push({ paramName: 'isUAE', paramValue: this.isNRC });
            this.isReportPatientMedicationVisible = true;
            this.$refs.patientMedications.buildDocument(reportParams);
        },

        ViewMed(item) {
            this.RecordId = item.recordId;
            this.VisibleModalViewMed = true;
        },

        CloseModalMed() {
            this.VisibleModalViewMed = false;
        },

        PerPageFunction2(perpage) {
            this.perPage2 = perpage;
            this.currentPage2 = 1;
        },

        RowClicked() {},

        ShowReport(item) {
            if (item) {
                if (item && item.recordId) {
                    this.recNoToReport = item.recordId;
                }
                this.isReportVisible = true;
            } else {
                setTimeout(
                    () =>
                        this.$bvToast.toast(this.$t('MdTable.nRecShow'), {
                            title: this.$t('Msg.Info'),
                            autoHideDelay: 3000,
                            variant: 'info'
                        }),
                    50
                );
            }
        },

        onFiltered2(filteredItems) {
            this.totalRows2 = filteredItems.length;
            this.currentPage2 = 1;
        },

        onRowSelected2(item) {
            this.selected = item;
        },

        pageChanged2(page) {
            this.currentPage2 = page;
        },

    async getMedications() {
        if(this.PatientCode){
        this.medications = [];
        await MedicationService.getMedicationsAll(this.PatientCode,true)
            .then((response) => {
            if (response.status == "200" && response.data && response.data.length > 0) {
               let data = response.data;

               data.forEach(element => {
                    element.selected = true;
               });


                this.medications = data;
            }
            })
            .catch((error) => {
            this.showResponseErrorMessage(error);
            });
        }
    },

    async MonographClick(Id){
        if(this.$store.state.UseFirstDataBank){
            await this.getProfessionalMonographsById(Id);
            this.VisibleProfessionalMonograph = true;
        }
    },

     async getProfessionalMonographsById(Id){
             await FirstDataBankService.getProfessionalMonographsById(Id)
            .then((response) => {
               this.ProfessionalMonographSectionList = response.data?.monograph?.sections;
               this.ProfessionalMonographReferenceList = response.data?.monograph?.referenceSections;
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    ProfessionalMonographOnCancel(){
        this.VisibleProfessionalMonograph = false;
    },

    getValuesDrugs(valueCodes,valueDescriptions){

        valueCodes.forEach((element, index)  => {
            if (!this.medications.some(x => x.drugCode === element)) {
                this.medications.push({drugCode:element,drugName:valueDescriptions[index], selected:true});
            }
        });
    },
     toggleMedication(medication) {
        medication.selected = !medication.selected
    },
      addMedication() {
      // Abrir modal, etc.
    },

    removeMedication(index) {
      this.medications.splice(index, 1)
    }
  },

  created(){
    if(this.PatientCode){
        this.getPatientMedications2(this.PatientCode);
    }

  },

  mounted(){
    this.getMedications();
  }

};
</script>

<style scoped>
.medications-card {
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  padding: 0;
}

/* Header */
.medications-header {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 55px;
  padding: 10px 14px;
}

.medications-title {
  color: #2864c7;
  font-size: 16px;
  font-weight: 500;
}

/* Botón + */
.add-medication-btn {
  position: absolute;
  right: 14px;
  top: 8px;

  width: 38px;
  height: 38px;
  padding: 0;

  border-radius: 50%;
  border: none;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.25);
}


.medications-list {
  max-height: 240px;
  overflow-y: auto;
}

/* Scroll */
.medications-list::-webkit-scrollbar {
  width: 6px;
}

.medications-list::-webkit-scrollbar-track {
  background: transparent;
}

.medications-list::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

/* Fila */
.medication-row {
  display: flex;
  align-items: center;
  min-height: 42px;
  width: 100%;
  min-width: 0;
  margin-bottom: 6px;
}

/* Checkbox */
/*.medication-checkbox {
  flex: 0 0 auto;
  margin-right: 10px;
}*/

/*
.medication-checkbox {
    margin: 0 !important;
}*/

/*.medication-checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
}

.medication-checkbox .custom-control-input {
    left: auto;
    top: auto;
    position: relative;
}*/
.medication-checkbox {
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
}

.medication-checkbox .custom-control-label {
    padding: 0 !important;
    margin: 0 !important;
}

.medication-checkbox .custom-control-label::before,
.medication-checkbox .custom-control-label::after {
    left: 50% !important;
    transform: translateX(-50%);
}



.medication-checkbox >>> .custom-control-label::before {
  border-radius: 0;
}

.medication-checkbox >>> .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ffc107;
  border-color: #ffc107;
}

/* Delete */
.delete-medication-btn {
  flex: 0 0 auto;

  padding: 0;
  margin-right: 14px;

  color: #222;
  line-height: 1;
}

.medication-delete-icon {
    width: 18px !important;
    height: 18px !important;
    min-width: 18px !important;
    min-height: 18px !important;
    font-size: 12px !important;
}

.delete-medication-btn:hover {
  color: #dc3545;
  text-decoration: none;
}

/* Nombre */
.medication-name {
  flex: 1 1 auto;

  min-width: 0;

  color: #2864c7;
  font-size: 14px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  cursor: default;
}

.medication-name:hover {
  text-decoration: underline;
}

/* Sin medicamentos */
.empty-medications {
  color: #999;
  text-align: center;
  padding: 20px 0;
  font-size: 14px;
}

/* =====================================
   CONTENEDOR GENERAL
===================================== */

.clinical-screening {
  width: 100%;
  padding: 0px 5px 20px;

  background: #ffffff;

  font-family: Arial, Helvetica, sans-serif;

  color: #333333;
}


/* =====================================
   CAJITA
===================================== */

.screening-box {
  width: 100%;
  margin-bottom: 12px;
  overflow: hidden;
  border-radius: 6px;
  background: #ffffff;
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.15);
}


/* =====================================
   TÍTULO
===================================== */

.box-title {
  height: 36px;

  display: flex;
  align-items: center;

  padding: 0 15px;

  background: #ffffff;

  border-bottom: 1px solid #dddddd;

  font-size: 14px;
  font-weight: 600;

  color: #555555;
}


/* =====================================
   HEADER GRIS
===================================== */

.alert-header {
  min-height: 84px;
border-radius: 6px 6px 0 0;
  display: flex;
  align-items: center;

  background: #e9e9e9;
}


/* =====================================
   ICONO
===================================== */

.warning-container {
  width: 64px;
  min-width: 64px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.warning-icon {
  width: 38px;
  height: 38px;

  display: block;
}


/* =====================================
   INFORMACIÓN
===================================== */

.alert-info {
  padding: 8px 10px 8px 0;
  width: 550px;
}


/* 2-Serious */

.severity2 {
  display: inline-block;

  margin-bottom: 2px;
  padding: 1px 10px;

  background: #ff812d;

  font-size: 14px;
  line-height: 17px;

  color: #333333;
}

.severity3 {
  display: inline-block;

  margin-bottom: 2px;
  padding: 1px 10px;

  background: #ffb921;

  font-size: 14px;
  line-height: 17px;

  color: #333333;
}

.severity1 {
  display: inline-block;

  margin-bottom: 2px;
  padding: 1px 10px;

  background: #e74c3c;

  font-size: 14px;
  line-height: 17px;

  color: #333333;
}



/* ID */

.alert-id {
  font-size: 13px;
  line-height: 17px;

  color: #333333;
}


/* Description */

.description {
  font-size: 13px;
  line-height: 17px;

  color: #333333;
}


/* =====================================
   BODY
===================================== */

.alert-body {
  padding: 13px 14px 14px;
  border-radius: 0 0 6px 6px !important;
  background: #f7eee5;
}


/* =====================================
   DESCRIPCIÓN
===================================== */

.message {
  margin-bottom: 11px;

  font-size: 13px;
  line-height: 18px;

  color: #333333;
}


/* =====================================
   MEDICAMENTOS
===================================== */

.medications {
  margin-top: 4px;
}

.medication {
  margin-bottom: 3px;

  font-size: 13px;
  line-height: 16px;

  font-weight: 700;

  color: #292929;
}


/* =====================================
   SEPARADOR
===================================== */

.separator {
  width: 100%;
  height: 1px;

  margin-top: 9px;
  margin-bottom: 9px;

  background: #999999;
}


/* =====================================
   MONOGRAPH
===================================== */

.monograph {
  display: inline-flex;
  align-items: center;

  color: #2867c7;

  font-size: 13px;

  text-decoration: none;

  cursor: pointer;
}

.monograph:hover {
  text-decoration: underline;
}


/* =====================================
   ICONO DOCUMENTO
===================================== */

.document-icon {
  position: relative;

  width: 15px;
  height: 19px;

  margin-right: 9px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  gap: 2px;

  padding: 4px 3px;

  background: #292929;

  border-radius: 1px;
}


/* Esquina doblada */

.document-icon::after {
  content: "";

  position: absolute;

  top: 0;
  right: 0;

  width: 0;
  height: 0;

  border-top: 5px solid #ffffff;
  border-left: 5px solid transparent;
}


/* Líneas */

.document-icon span {
  display: block;

  width: 8px;
  height: 1px;

  background: #ffffff;
}

.duplicate-therapy-box {
  width: 100%;
  margin-top: 0;


  overflow: hidden;

  background: #ffffff;


  border-radius: 0 0 3px 3px;

  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18);
}


/* =================================
   HEADER GRIS
================================= */

.duplicate-header {
  height: 49px;

  display: flex;
  align-items: center;

  padding: 0 3px;

  background: #e9e9e9;

  border-bottom: 1px solid #dddddd;

  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 700;

  color: #292929;
}


/* =================================
   BODY
================================= */

.duplicate-body {
  min-height: 70px;

  padding: 16px 3px 12px;

  background: #f7eee5;

  font-family: Arial, Helvetica, sans-serif;
}


/* =================================
   MEDICAMENTOS
================================= */

.duplicate-medication {
  margin: 0 0 4px 0;

  font-size: 14px;
  line-height: 17px;

  font-weight: 400;

  color: #292929;
}


/* =====================================
   RESPONSIVE
===================================== */

@media (max-width: 600px) {

  .box-title {
    font-size: 13px;
  }

  .alert-header {
    min-height: 90px;
  }

  .warning-container {
    width: 55px;
    min-width: 55px;
  }

  .warning-icon {
    width: 34px;
    height: 34px;
  }

  .description {
    font-size: 12px;
  }

  .message {
    font-size: 12px;
  }

}
</style>


